import scanTree from './ScanTree';

export default function createDomTree(rootNode) {
    let rootDom = rootNode.el;
    scanTree(rootNode, function(vnode){
        let dom = vnode.el;
        let children = vnode.children || [];
        for(let child of children) {
            if (child.el) {
                dom.appendChild(child.el);
            }
        }
        return true;
    });
    return rootDom;
}